import types from '../../types';

const initialState = {
  loading: false,
  securityOptions: null,
  uniqueDevices: null,
  whitelistAddresses: null,
};

const userSecurity = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GET_USER_SECURITY_OPTIONS_START:
    case types.GET_USER_UNIQUE_DEVICES_START:
    case types.DELETE_USER_UNIQUE_DEVICE_START:
    case types.GET_USER_WITHDRAWAL_WHITELIST_ADDRESSES_START:
      return { ...state, loading: true };

    case types.GET_USER_SECURITY_OPTIONS_SUCCESS:
      return { ...state, securityOptions: payload, loading: false };

    case types.GET_USER_UNIQUE_DEVICES_SUCCESS:
      return { ...state, uniqueDevices: payload, loading: false };

    case types.GET_USER_WITHDRAWAL_WHITELIST_ADDRESSES_SUCCESS:
      return { ...state, whitelistAddresses: payload, loading: false };

    case types.DELETE_USER_UNIQUE_DEVICE_SUCCESS:
      return {
        ...state,
        uniqueDevices: state.uniqueDevices.filter(
          el => el.id !== payload.params.device_id,
        ),
        loading: false,
      };

    case types.GET_USER_SECURITY_OPTIONS_FAILURE:
    case types.GET_USER_UNIQUE_DEVICES_FAILURE:
    case types.DELETE_USER_UNIQUE_DEVICE_FAILURE:
    case types.GET_USER_WITHDRAWAL_WHITELIST_ADDRESSES_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default userSecurity;
